import { DOM_IDS, MOBILE_BREAKPOINT } from '../constants.js'
import { shouldShowHeaderSlots, shouldShowAicPanel } from '../config.js'
import { waitForElement } from '../dom-helpers.js'
import { createSubApp } from './create-sub-app.js'

const loadRightSlots = () => import('../right-slots.vue')

function buildRightProps({ ctx }) {
  return {
    showAicPanel: shouldShowAicPanel(ctx),
    showRollback:
      window.innerWidth > MOBILE_BREAKPOINT &&
      ctx.rollbackToClassicSupported &&
      !ctx.toggleControlBySetting
    //rightCustoms: header?.customs?.right ?? []
  }
}

function createAicPanel() {
  const panel = document.createElement('div')
  panel.classList.add('aic-side-panel')
  panel.id = 'aic-side-panel'
  const target = document
    .getElementById('content')
    .querySelector('.mini-layout .mini-layout-body .row')
  if (target) {
    target.appendChild(panel)
  }
}
export async function mountRightSlots({ ctx }) {
  if (!shouldShowHeaderSlots()) return

  const container = await waitForElement(DOM_IDS.RIGHT_SLOTS)
  if (!container) return

  const { default: RightSlots } = await loadRightSlots()

  if (shouldShowAicPanel(ctx)) {
    createAicPanel()
  }
  createSubApp({
    component: RightSlots,
    container,
    scope: 'right-slots',
    props: buildRightProps({ ctx })
  })
}
